import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Briefcase, LayoutDashboard, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/t3J9pG9VM9s2YNfBdSCinK/Logo_Kementerian_Lingkungan_Hidup_-_Badan_Pengendalian_Lingkungan_Hidup_(2024).png';
export function PortalSelector() {
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-900" data-id="element-3811">
      {/* Header */}
      <header className="bg-white border-b py-6" data-id="element-3812">
        <div className="container mx-auto px-4 text-center" data-id="element-3813">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-3814">
            <img src={LOGO_URL} alt="Logo Kementerian Lingkungan Hidup / BPLH" className="h-12 w-12 object-contain" data-id="element-3815" />
            <div className="text-left" data-id="element-3816">
              <span className="font-bold text-2xl text-gray-900 tracking-tight block" data-id="element-3817">
                Indonesia ASRI Hub
              </span>
              <span className="text-xs text-gray-500" data-id="element-3818">
                Kementerian Lingkungan Hidup / BPLH
              </span>
            </div>
          </div>
          <h1 className="text-xl font-medium text-gray-600 mt-2" data-id="element-3819">
            Platform KIE Pengelolaan Sampah Nasional
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 container mx-auto px-4 py-12 md:py-20" data-id="element-3820">
        <div className="max-w-4xl mx-auto" data-id="element-3821">
          <div className="text-center mb-12" data-id="element-3822">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-3823">
              Pilih Portal Akses
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-3824">
              Platform Nasional KIE Pengelolaan Sampah terintegrasi untuk
              masyarakat, petugas, dan pemerintah pusat.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3825">
            {/* Public Portal Card */}
            <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full relative overflow-hidden group" data-id="element-3826">
              <div className="absolute top-0 left-0 w-full h-1 bg-primary-500" data-id="element-3827"></div>
              <CardHeader className="pt-10 pb-4 text-center" data-id="element-3828">
                <div className="mx-auto bg-primary-50 text-primary-600 p-4 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-3829">
                  <Users className="h-8 w-8" data-id="element-3830" />
                </div>
                <CardTitle className="text-xl mb-2" data-id="element-3831">Portal Publik</CardTitle>
                <CardDescription className="text-center" data-id="element-3832">
                  Untuk Masyarakat Umum
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center text-gray-600 flex-1" data-id="element-3833">
                <p data-id="element-3834">
                  Akses konten edukasi, ikuti event nasional, dan laporkan isu
                  lingkungan di sekitar Anda.
                </p>
              </CardContent>
              <CardFooter className="pt-0 pb-8 justify-center" data-id="element-3835">
                <Link to="/" className="w-full" data-id="element-3836">
                  <Button className="w-full bg-primary-600 hover:bg-primary-700 text-white gap-2" data-id="element-3837">
                    Masuk Portal <ArrowRight className="h-4 w-4" data-id="element-3838" />
                  </Button>
                </Link>
              </CardFooter>
            </Card>

            {/* Officer App Card */}
            <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full relative overflow-hidden group" data-id="element-3839">
              <div className="absolute top-0 left-0 w-full h-1 bg-secondary-500" data-id="element-3840"></div>
              <CardHeader className="pt-10 pb-4 text-center" data-id="element-3841">
                <div className="mx-auto bg-secondary-50 text-secondary-600 p-4 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-3842">
                  <Briefcase className="h-8 w-8" data-id="element-3843" />
                </div>
                <CardTitle className="text-xl mb-2" data-id="element-3844">Aplikasi Officer</CardTitle>
                <CardDescription className="text-center" data-id="element-3845">
                  Untuk Penyuluh & Petugas
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center text-gray-600 flex-1" data-id="element-3846">
                <p className="mb-4" data-id="element-3847">
                  Submit laporan kegiatan terstandar, kelola checklist program,
                  dan eskalasi isu lapangan.
                </p>
                <Badge variant="outline" className="bg-gray-50 text-gray-500 border-gray-200" data-id="element-3848">
                  Memerlukan Login
                </Badge>
              </CardContent>
              <CardFooter className="pt-0 pb-8 justify-center" data-id="element-3849">
                <Link to="/login?role=officer" className="w-full" data-id="element-3850">
                  <Button className="w-full bg-secondary-600 hover:bg-secondary-700 text-white gap-2" data-id="element-3851">
                    Masuk Aplikasi <ArrowRight className="h-4 w-4" data-id="element-3852" />
                  </Button>
                </Link>
              </CardFooter>
            </Card>

            {/* Command Center Card */}
            <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full relative overflow-hidden group" data-id="element-3853">
              <div className="absolute top-0 left-0 w-full h-1 bg-gray-800" data-id="element-3854"></div>
              <CardHeader className="pt-10 pb-4 text-center" data-id="element-3855">
                <div className="mx-auto bg-gray-100 text-gray-800 p-4 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-3856">
                  <LayoutDashboard className="h-8 w-8" data-id="element-3857" />
                </div>
                <CardTitle className="text-xl mb-2" data-id="element-3858">Command Center</CardTitle>
                <CardDescription className="text-center" data-id="element-3859">
                  Untuk KLH/BPLH Pusat
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center text-gray-600 flex-1" data-id="element-3860">
                <p className="mb-4" data-id="element-3861">
                  Dashboard monitoring nasional, skoring daerah, manajemen
                  konten, dan krisis.
                </p>
                <Badge variant="outline" className="bg-gray-50 text-gray-500 border-gray-200" data-id="element-3862">
                  Akses Admin Pusat
                </Badge>
              </CardContent>
              <CardFooter className="pt-0 pb-8 justify-center" data-id="element-3863">
                <Link to="/login?role=admin" className="w-full" data-id="element-3864">
                  <Button className="w-full bg-gray-800 hover:bg-gray-900 text-white gap-2" data-id="element-3865">
                    Masuk Dashboard <ArrowRight className="h-4 w-4" data-id="element-3866" />
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t py-8 text-center text-sm text-gray-500" data-id="element-3867">
        <div className="container mx-auto px-4" data-id="element-3868">
          <p className="mb-2 font-medium text-gray-700" data-id="element-3869">
            Kementerian Lingkungan Hidup / Badan Pengendalian Lingkungan Hidup
            (KLH/BPLH)
          </p>
          <p className="mb-2" data-id="element-3870">Republik Indonesia</p>
          <p className="text-xs text-gray-400" data-id="element-3871">
            © {new Date().getFullYear()} Indonesia ASRI Hub - Platform Nasional
            KIE Pengelolaan Sampah
          </p>
        </div>
      </footer>
    </div>;
}